const routes = [
  {
    path: 'dashboard',
    name: 'Dashboard',
    meta: { middleware: 'AuthAdmin|AuthRegionalDirector|AuthHeadDepartment|AuthHeadResident|AuthDashboard' },
    component: () =>
    import("@/views/dashboard/Dashboard"),
  }
]

export default routes;
